// extracted by mini-css-extract-plugin
module.exports = {"quiz":"Quiz_quiz__2z5x1","page":"Quiz_page__3VNaP"};